export default __webpack_public_path__ + "static/gartner_peer_insights-0f726e9fb47b13d78a675f4691da2c40.png";